import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BookmarkIcon = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke={props.color ?? '#3379BD'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8 10.963-4 2.37V3.26c0-.157.06-.308.167-.419a.561.561 0 0 1 .404-.173h6.858c.151 0 .296.062.404.173a.604.604 0 0 1 .167.42v10.073l-4-2.37Z"
    />
  </Svg>
);
export default BookmarkIcon;
